import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import Apps from "./apps.jsx";
import {Provider} from "react-redux";
import store from './modules/stores';

import {interfaceJs} from "./modules/func";

/** @type {JQueryStatic} */
export const $ = window.jQuery;
/** @type {*|JSIBase} */
export const jsi = interfaceJs();

export const targetWindow = window.parent || window;

window.Interface = jsi;

(function () {
    // regist custom event
    if (typeof window.CustomEvent !== "function") {
        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: null };
            const evt = document.createEvent('CustomEvent');
            // noinspection JSDeprecatedSymbols
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    }
})();

const apps = document.getElementById("rhymeduck-player");

// noinspection JSCheckFunctionSignatures
ReactDOM.render(
    <Provider store={store}>
        <Apps />
    </Provider>,
    apps
);



// WEBPACK FOOTER //
// ./src/index.js